var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('create-link',{on:{"create":function($event){return _vm.$refs.list.update()}}}),_c('link-list',{ref:"list"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }